<template>
  <div id="app">
    <router-view :key="$store.state.reloadKey"/>
  </div>
</template>

<script>
import { useActivityStore } from '@/store/activity'
import { mapState } from 'vuex';
export default {
  name: 'App',
  //components: {
    //NetworkCheck,  // Register the NetworkCheck component
  //},
  computed: {
    ...mapState({
      pushId: state => state.pushId,
    }),
  },
  mounted() {
    // Listen to the storage event (for cross-tab logout)
    window.addEventListener('storage', this.onStorageChange);
    const activityStore = useActivityStore()
    // Load from localStorage
    activityStore.loadFromLocalStorage()
    // Refresh relative time every 60 seconds
    setInterval(() => {
      activityStore.refreshTimeLabels()
    }, 60000)
  },
  beforeDestroy() {
    // Cleanup the listener when the component is destroyed
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === 'token' && !event.newValue) {
        //console.log('Token removed from another tab. Logging out...');
        this.$store.dispatch('logout'); // Logout when token is removed in another tab
        this.$router.push('/login'); // Redirect user to login page
      }
    }
  },
  watch: {
    pushId(newPushId, oldPushId) {
      if (newPushId && newPushId !== oldPushId) {
        //console.log(`Push ID changed: Syncing new push ID ${newPushId}`);
        this.$store.dispatch('syncUserIdWithServer');
      }
    },
  },
};
</script>
